import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import {useNavigate} from "react-router-dom";


export default function Footer() {

	const navigate = useNavigate();

	const Copyright = ()=> {
		return (
			<Typography variant="body2" color="text.secondary" sx={{display:'flex', justifyContent:'center'}}>
				{"Copyright⠀©⠀"}
				<Link color="inherit" onClick={() => navigate('/')}>
					MicroStores
				</Link>{'⠀'}
				{new Date().getFullYear()}
				{'.'}
			</Typography>
		);
	}

	return (
		<Box
			component="footer"
			sx={{
				marginTop:'auto', width: '100%', py: 2, px: 2, mt: 'auto',
				backgroundColor: (theme) =>
					theme.palette.mode === 'light'
						? theme.palette.grey[300]
						: theme.palette.grey[800],
			}}
		>
			<Container maxWidth="sm">
				<Copyright />
			</Container>
		</Box>
	);
}